export default __webpack_public_path__ + "static/media/video-banner2.1c4d10cb.png";